
import Vue from 'vue'
import store from '@/store'
import { isString, isArray } from '@/utils/validate'
import settings from '@/settings'
import { reportFrontendError } from '@/utils/observability'

// you can set in settings.js
// errorLog:'production' | ['production', 'development']
const { errorLog: needErrorLog } = settings

function checkNeed() {
  const env = process.env.NODE_ENV
  if (isString(needErrorLog)) {
    return env === needErrorLog
  }
  if (isArray(needErrorLog)) {
    return needErrorLog.includes(env)
  }
  return false
}

if (checkNeed()) {
  Vue.config.errorHandler = function(error, vm, info, a) {
    // Don't ask me why I use Vue.nextTick, it just a hack.
    // detail see https://forum.vuejs.org/t/dispatch-in-vue-config-errorhandler-has-some-problem/23500
    Vue.nextTick(() => {
      store.dispatch('log/addLog', {
        type: 'error',
        error,
        vm,
        info,
        url: window.location.href,
        date: new Date().getTime()
      })
      reportFrontendError(error)
      console.error(error, info)
    })
  }
  window.onerror = (message, source, lineno, colno, error) => {
    store.dispatch('log/addLog', {
      type: 'error',
      error,
      url: window.location.href
    })
    reportFrontendError(error || new Error(String(message || 'Window error')))
  }

  window.addEventListener('error', event => {
    store.dispatch('log/addLog', {
      type: 'error',
      error: event.error,
      url: window.location.href
    })
    if (event.error) {
      reportFrontendError(event.error)
    }
  })

  window.addEventListener('unhandledrejection', event => {
    store.dispatch('log/addLog', {
      type: 'error',
      error: event.reason,
      url: window.location.href
    })
    reportFrontendError(event.reason || new Error('Unhandled promise rejection'))
  })
}
